import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GetSalesConfigResponseInterface,
  SalesConfigInputsInterface,
  SetSalesConfigResponseInterface,
} from '@vendasta/partner';
import { GetSalesConfigRequest, SetSalesConfigRequest } from '@vendasta/partner';
import { SalesApiService } from '@vendasta/partner';
import { PartnerSalesServiceInterface } from './interfaces';

@Injectable({ providedIn: 'root' })
export class PartnerSalesService implements PartnerSalesServiceInterface {
  constructor(private api: SalesApiService) {}

  setConfiguration(
    partnerId: string,
    marketId: string,
    config: SalesConfigInputsInterface,
  ): Observable<SetSalesConfigResponseInterface> {
    const req = new SetSalesConfigRequest({
      partnerId: partnerId,
      marketId: marketId,
      config: config,
    });
    return this.api.setConfiguration(req);
  }

  getConfiguration(partnerId: string, marketId: string): Observable<GetSalesConfigResponseInterface> {
    const req = new GetSalesConfigRequest({
      partnerId: partnerId,
      marketId: marketId,
    });
    return this.api.getConfiguration(req);
  }
}
